import {computed} from '@api'
import {VipLocalStore} from '@modules'
import {StoresInstance} from '@stores'

interface IGroupByPageTitle {
  group?: any
}

export class GroupByPageTitleStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: IGroupByPageTitle) {super(stores) }

  @computed get group() {
    const {props} = this
    return props.group
  }

  @computed get key() {
    return this.group.key
  }

  get grouping() {
    const {pdf: {grouping}} = this
    return grouping
  }

  get layout() {
    const {pdf: {config: {layout}}} = this
    return layout
  }

  @computed get title() {
    const {grouping: {groupName, fullTitle}, layout, strings, group} = this
    let title = fullTitle ?? group.title ?? group.key_as_string ?? group.keys[groupName] ?? group.key.toString()
    title = layout === 'column' ? group.title : title === '' ? strings.noValue : title
    return title
  }

  @computed get subtitle() {
    const {group, grouping: {fieldDefinition: {group: groupDef}}, strings} = this
    return group.subtitle1 ?? groupDef?.subtitle ? groupDef?.subtitle?.map(({field, prefix}) => {
      const value = _.get(group._source ?? group.keys, field)
      return value !== null ? `${prefix || ''}${value}` : strings.noValue
    }).filter(_.identity).join(', ') : strings.emptyLabel
  }

  @computed get total() {
    const {group} = this
    return group?.items?.total ?? {value: 0}
  }

  @computed get spec() {
    const {group, title, subtitle, total} = this
    return {title, subtitle, ...group, doc_count: total.value}
  }

}


// WEBPACK FOOTER //
// ./src/modules/pdf/templates/vlp/GroupByPageTitleStore.ts